"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PostLoader;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PostLoader() {
  return _react.default.createElement(_commonReact.ContentLoader, {
    height: "175",
    width: "100%"
  }, _react.default.createElement("rect", {
    x: "0",
    y: "1",
    rx: "6",
    ry: "6",
    width: "280",
    height: "175"
  }));
}